<div class="panel-heading">
	<button type="button" (click)= "onRemove()" class="close" style="color: #ffffff; margin-left: 10px; display: block">
		&times;
	</button>

	<!-- Minimize/Maximize Arrows -->
	<button (click)="showBody = !showBody" type="button" class="close" style="color: #ffffff; margin-left: 10px;">
		<i *ngIf="showBody" class="fa fa-angle-double-up"></i>
		<i *ngIf="!showBody" class="fa fa-angle-double-down"></i>
	</button>
	
	<h1 class="panel-title" style="display: inline-block; width: 90%">
		<div style="display: inline-block">
			<i class="fa fa-calendar" ></i>&nbsp;DAYS(S) AND TIME(S)
		</div>
	</h1>
</div>

<div class="panel-body">
	<div class="row">
		<!-- days -->
		<div class="col-sm-7">
			<div class="panel panel-drk-orange">
				<div class="panel-body">
					<h3>
						<i class="fa fa-sun-o" aria-hidden="true"></i>
						DAY(S)
					</h3>
					<div *ngFor="let day of days" style="display: block" >
						<label>
							<input (click)="onDayClick($event)" type="checkbox" value="{{day.value}}" [(ngModel)]="day.checked" />
							{{day.label}}
						</label>
					</div>
				</div>
			</div>
		</div>
		
		<!-- time -->
		<div class="col-sm-5">
			<div class="panel panel-drk-orange">
				<div class="panel-body">
					<h3>
						<i class="fa fa-clock-o" aria-hidden="true"></i>
						TIME(S)
					</h3>
				</div>
				<div class="panel-body">
					<label for="startTime">START TIME:</label>
					<input id="startTime" class="form-control" type="time" [(ngModel)]="rule.startTime" />
					<label for="startTime">END TIME:</label>
					<input id="startTime" class="form-control" type="time" [(ngModel)]="rule.endTime" />
				</div>
			</div>		
		</div>
	</div>
</div>